import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { dummyListKategori, dummyListProduk } from "../dummy-data";
import ProdukBox from "../components/ProdukBox";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import SearchInputText from "../components/SearchInputText";
import UiContext from "../../../store/ui-context";
import AppContext from "../../../store/app-context";
import { Button } from "primereact/button";

const isNotMobile = window.innerWidth >= 640;

const TokoPage = () => {
  const { id } = useParams();
  const uiContext = useContext(UiContext);
  const appContext = useContext(AppContext);
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const [filterText, setFilterText] = useState("");
  const [listProduk, setListProduk] = useState([]);
  const [toko, setToko] = useState();

  const [paging, setPaging] = useState({
    page: 1,
    take: 20,
    filter: "",
    total: 0,
  });

  // use effect section

  useEffect(() => {
    if (appContext.selectedKota) {
      fetchKategori(id);
    }
  }, [appContext.selectedKota]);

  useEffect(() => {
    if (appContext.selectedKota && toko) {
      fetchListProduk(paging, true);
    }
  }, [appContext.selectedKota, toko]);

  // api call section
  const fetchKategori = async (tokoId) => {
    return requestGetOne({
      fullUrl: `/api/masterdata/toko/one/${tokoId}`,
      onSuccess: ({ pagination, message, data }) => {
        if (data) {
          setToko(data);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });

    // const _toko = dummyListKategori.find(
    //   (toko) => toko.id == tokoId
    // );
    // setToko(_toko);
    // fetchListProduk();
  };

  const fetchListProduk = async (_paging, reset) => {
    const _newPaging = _paging || paging;

    if (reset) {
      _newPaging.page = 1;
    }

    const selectedKota = appContext.selectedKota;
    const filterArr = [];
    if (selectedKota) {
      filterArr.push(`kota_id:=:${selectedKota.id}`);
    }

    if (toko) {
      filterArr.push(`toko_id:=:${toko.id}`);
    }

    const _filterText = filterText.toLowerCase();
    if (_filterText && _filterText.length > 0) {
      filterArr.push(`nama:contains:${_filterText}`);
    }

    const _filter = filterArr.join(";");

    return requestGet({
      fullUrl: `/api/masterdata/produk/data`,
      params: {
        page: _newPaging.page,
        take: _newPaging.take,
        filter: _filter,
        order: "nama",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        if (reset) {
          setListProduk(data);
        } else {
          setListProduk([...listProduk, ...data]);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // ui handler section
  const handleSearch = (filterText) => {
    fetchListProduk(paging, true);
  };

  const handleOnClickedLoadMore = () => {
    const _paging = { ...paging, page: paging.page + 1 };
    setPaging(_paging);
    fetchListProduk(_paging, false);
  };

  return (
    <div className="col-start-start gap-1">
      {/* header section */}
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 pt-2 pb-6">
        {/* greeting */}
        <div className="row-start-center gap-2 py-4">
          <Link className="px-1" to={-1}>
            <i className="pi pi-arrow-left text-slate-600 text-[0.8rem]" />
          </Link>
          <span className="text-slate-700 text-xl leading-none">
            {toko?.nama_toko ?? "-"}
          </span>
        </div>

        {/* search  */}
        <SearchInputText
          loading={loading}
          value={filterText}
          placeholder={`Find In ${toko?.nama_toko ?? "-"}`}
          onChange={(_text) => setFilterText(_text)}
          onSearch={(text) => handleSearch(text)}
        />
      </div>

      {/* list section  */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap justify-start items-start bg-white w-full shadow-xs px-3 sm:px-5 py-4 gap-4">
        {listProduk.map((produk) => (
          <ProdukBox
            key={`list-kategory-produk-${produk.id}`}
            {...produk}
            size={isNotMobile ? "medium" : "large"}
          />
        ))}
      </div>

      <div className="row-center-center py-2 w-full">
        <Button
          className="opacity-80"
          icon="pi pi-sort-down-fill"
          label="Load more"
          loading={loading}
          // outlined
          rounded
          onClick={() => {
            handleOnClickedLoadMore();
          }}
        />
      </div>
    </div>
  );
};

export default TokoPage;
